export default __webpack_public_path__ + "static/media/17-zone.235ee416.jpg";